import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'
import SelectSearch, { fuzzySearch } from 'react-select-search';
import Swal from 'sweetalert2';
import Topnav from '../../../components/adminNav/Topnav';
import Sidebar from '../../../components/sidebar/Sidebar';
import { BASE_URL } from '../../../requestMethod';

const EditProduct = () => { 
    const location = useLocation();
    const path = location.pathname?.split("/")[2];
    const user = useSelector((state) => state.user.currentUser);
    const [product, setProduct] = useState({})

    useEffect(() => {
        const getProduct = async () => {
            try {
                const res = await axios.get(`${BASE_URL}Product/${path}`, {
                    mode: 'no-cors',
                    headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
                })
                // console.log(res.data.returnObj);
                setProduct(res.data.returnObj);
            }
            catch (err) {
                console.log(err)
            }
        }
        getProduct();
    }, [path])


    const [chose, setChose] = useState(false);
    const [name, setName] = useState(product.name);
    const [minimumPrice, setMinimumPrice] = useState(product.minimumPrice);
  
    const [chooseImg, setChooseImg] = useState(product.imageUrl);
    const [imageToggle, setImageToggle] = useState(false);
    const [cloudImages, setCloudImages] = useState([]);
  
    const [chooseTag, setchooseTag] = useState("");
    const [openCreateTag, setOpenCreateTag] = useState(false);
    const [tagList, settagList] = useState([]);
    const [tagName, settagName] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [isUploadLoading, setIsUploadLoading] = useState("");
  
    const useTagList = [];
  
    useEffect(() => {
      
      getBaskets();
    }, []);
  
    const getBaskets = async () => {
      try {
        const res = await axios.get(`${BASE_URL}Image/firebaseGallery?vendorId=${user.returnObj.vendorId}`);
        // console.log(res.data);
        setCloudImages(res.data.returnObj);
      } catch (err) {
        console.log(err);
      }
    };
    useEffect(() => {
  
      getTags();
    }, []);
  
    const getTags = async () => {
      const res = await axios.get(`${BASE_URL}Product/Tags`);
      const tagList = res.data.returnObj;
      tagList.forEach((e) => {
        useTagList.push({
          id: e.id,
          name: e.name,
          value: e.id,
        });
      });
      //console.log(useTagList);
      settagList(useTagList);
    };
  
    const selectTag = (tagId) => {
      //console.log("tagid", tagId);
      setchooseTag(tagId);
    };
  
    const selectImage = (imgs) => {
      
      setChose(true);
      setChooseImg(imgs);
      setImageToggle(false);
    };
    const [selectedFile, setselectedFile] = useState(null);
    const onFileChange = (event) => {
      //console.log("selectedfile", event.target.files[0]);
      setselectedFile(event.target.files[0]);
    };
  
    const uploadImageFromFile = async (e) => {
      e.preventDefault();
      if(selectedFile == null) {
        setIsUploadLoading("Please selecte a file...")
        return;
      }
      let formData = new FormData();
  
      setIsUploadLoading("Uploading...")
      formData.append("file", selectedFile);
      formData.append("vendorId", user.returnObj.vendorId);
      formData.append("vendorName", user.returnObj.customerName);
  
      try {
        await axios
        .post(`${BASE_URL}Image/uploadfirebase`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => { 
          if(res.data.status){
            console.log(res)
            setIsUploadLoading("Done!")
            getBaskets();
          }
          else{
             console.log(res)
            setErrMsg(res.data.returnObj)
            setIsUploadLoading("")
          }
        })
        .catch((err) => console.log(err));
      } catch (error) {
        console.log(error)
      }
    };
  
    const creatTag = async (e) => {
      e.preventDefault();
      try {
        const res = await axios.post(`${BASE_URL}Product/Tag`, { name: tagName }, {
          mode: "no-cors",
          headers: { Authorization: `Bearer ${user.returnObj.token}` },
        });
        // console.log(tagName);
        console.log(res.data);
        if (res.data.status) {
          Swal.fire({
            title: "Success",
            text: res.data.response,
            icon: "success",
            confirmButtonText: "Thanks",
          });
  
          getTags();
  
        } else {
          Swal.fire({
            title: "Error!",
            text: res.data.response,
            icon: "error",
            confirmButtonText: "Cancel",
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      const mprice = minimumPrice? parseInt(minimumPrice) : product.minimumPrice;
      const nam = name ? name : product.name;
      const model = {
        id:path,
        name: nam,
        minimumPrice: mprice,
        imageUrl: chooseImg ? chooseImg : product.imageUrl,
        inSeason: true,
        isSuggested: false,
        vendorId: user.returnObj.vendorId,
        tagId: chooseTag ? chooseTag :product.tagId,
      };
     // console.log(model)
      try {
        const res = await axios.post(`${BASE_URL}Product/putProduct`, model, {
          mode: "no-cors",
          headers: { Authorization: `Bearer ${user.returnObj.token}` },
        });
        console.log(model);
        console.log(res.data);
        if (res.data.status) {
          Swal.fire({
            title: "Success",
            text: res.data.response,
            icon: "success",
            confirmButtonText: "Thanks",
          });
          //toast.success(res.data.response)
          window.location.replace("/products");
        } else {
          Swal.fire({
            title: "Error!",
            text: res.data.response,
            icon: "error",
            confirmButtonText: "Cancel",
          });
        }
      } catch (err) {
        console.log(err);
        Swal.fire({
          title: "Error!",
          text: err,
          icon: "error",
          confirmButtonText: "Cancel",
        });
      }
    };
    
  return (
    <div className="container-scroller">
      <Topnav />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="content-wrapper">
          <div className="page-header">
            <h3 className="page-title"> Edit Product </h3>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#"></a>
                </li>
              </ol>
            </nav>
          </div>
          <div className="row">
            <div className="col-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Create A Product</h4> */}
                  <form className="forms-sample">
                    <div className="row">
                      <div className="col-md-4 col-sm-12">
                        <div className="form-group">
                          {/* <label>Name</label> */}
                          <input
                            type="text"
                            className="form-control"
                            onChange={(e) => setName(e.target.value)}
                            defaultValue={product.name}
                          />
                        </div>

                        {/* minimum price */}
                        <div className="form-group">
                          {/* <label htmlFor="mp">Minimum Price</label> */}
                          <input
                            type="number"
                            className="form-control"
                            id="mp"
                            onChange={(e) => setMinimumPrice(e.target.value)}
                            defaultValue={product.minimumPrice}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="tag">Select Tag</label>
                          <SelectSearch
                            options={tagList}
                            SelectSearch={product.tagID}
                            onChange={(e) => selectTag(e)}
                            search
                            filterOptions={fuzzySearch}
                            placeholder="Select tag"
                          />
                        </div>

                        <div className="form-group">
                          <a className="pointer" onClick={() => setOpenCreateTag(!openCreateTag)}>New Tag</a>

                          {

                            openCreateTag &&
                            (<>
                              <span>&nbsp;&nbsp;</span>
                              <input onChange={(e) => settagName(e.target.value)} type="text" placeholder="Create new Tag" />
                              <button className="btn btn-primary" onClick={creatTag}>Save</button>
                            </>)

                          }
                        </div>
                        <div className="form-group">
                          <span>Selected Image: </span> {(<p style={{ color: "green" }}>{chooseImg}</p>)}
                        </div>

                        <div className="row form-inline">
                          <button
                            type="submit"
                            onClick={handleSubmit}
                            className="btn btn-gradient-primary me-2"
                          >
                            Update
                          </button>
                          <a href="/products" className="btn btn-light">
                            Cancel
                          </a>
                        </div>
                      </div>
                      <div className="col-md-1 d-none d-md-block mx-auto">
                        <div className="vertical-line"></div>
                      </div>
                      <div className="col-md-7 col-sm-12">
                        <h5>Select image for new product</h5>
                        {errMsg && (<p style={{color:"red"}}>{errMsg}</p>)}
                        {isUploadLoading && (<p style={{color:"green"}}>{isUploadLoading}</p>)}
                        <h4>OR</h4>
                        <div className="row mt-3">
                          <div className="col-sm-4 my-auto">
                          
                            <input
                              type="file"
                              onChange={(e) => onFileChange(e)}
                              id="fileInput"
                              
                            />
                            {/* <span>{selectedFile?.name}</span> */}
                          </div>
                          <div className="col-sm-6">
                          
                            <button
                              className="btn btn-light"
                              onClick={uploadImageFromFile}
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                        <div class="lightbox scr">
                          <div className="row">
                            {cloudImages.map((imgs) => (
                              <div
                                key={imgs.url}
                                className={`col-sm-12 col-md-3 img-card border ${chose ? "img-card-select" : ""
                                  }`}
                                onClick={() => selectImage(imgs.url)}
                              >
                                <img
                                  src={imgs.url}
                                  alt={imgs.url}
                                  height={100}
                                  className="w-100 mb-2 mb-md-4 rounded"
                                />
                              </div>
                            ))}
                          </div>
                          <div className="row mt-2">
                            <div className="col-sm-6">{selectedFile?.path}</div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditProduct